import { IoMdArrowDropdown } from 'react-icons/io';
import { RequiredField } from '../../../utils/components';

import './Select.css';

export const Select = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  className,
  containerClassName,
  error,
  required,
  ...props
}) => {
  return (
    <div
      className={`form-select ${containerClassName || ''} ${
        error ? 'form-select--error' : ''
      }`}
    >
      <label className='form-select__label'>
        {label}
        {required && <RequiredField />}
      </label>

      <div className='form-select__wrapper'>
        <select
          className={`form-select__input ${className || ''}`}
          value={value}
          onChange={onChange}
          {...props}
        >
          {placeholder && (
            <option value='' disabled>
              {placeholder}
            </option>
          )}
          {options.map((option, index) => (
            <option key={`option-${index}-${option}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <IoMdArrowDropdown className='form-select__icon' />
      </div>

      <p className='form-select__error'>{error || ''}</p>
    </div>
  );
};
